<template>
    <div class="page">
        <div class="page-header">
            <h1 class="pl-5 title text-light">Aviso Legal</h1>
        </div> 
        <main>
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-10 mx-auto py-4">

                        <h3>Condiciones de uso</h3>

                        <p>Por favor, lea atentamente las siguientes condiciones generales. </p>

                        <p> Por el acceso a <a href="https://especial.edadeoro.es">edadeoro.es</a> (en adelante el “Sitio Web”) y/o a cualquiera de sus
                            páginas, usted tendrá la consideración de Usuario presumiéndose que acepta estas Condiciones
                            de Uso.</p>

                        <p>Las presentes condiciones regulan el uso permitido del Sitio Web para dar cumplimiento al
                            artículo 10 de la ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información
                            y del Comercio Electrónico. </p>

                        <h5>1. Destinatarios</h5>
                        <p>La información contenida en este Sitio Web, incluidos ciertos productos y servicios, está
                        destinada a su distribución o uso por personas físicas o jurídicas con residencia en España o
                        que accedan desde España. El Titular declina toda responsabilidad por el acceso de Personas en
                        jurisdicciones donde dicha visualización, distribución o uso pudieran ser contrarios a la
                        legislación vigente en cada momento.</p>

                        <h5>2. Información general</h5>
                        <p>A continuación, se detallan los datos de información general de este sitio Web:</p>

                        <p>Titular: <a href="https://viajescemo.com" target="_blank"> VIAJES CEMO S.A. </a><br>
                        Inscripción: Registro Mercantil de Almería, al Folio 208, Tomo 30 General Sección 3ª Libro de
                        Sociedades, Hoja 685 Inscripción 1ª<br>
                        Domicilio: Avenida de las Gaviotas 12-14, 04740 Roquetas de Mar, Almería, España.<br>
                        Teléfono: (+34) 950627019<br>
                        E-mail: roquetas@viajescemo.com</p>

                        <h5>3. Protección de Datos Personales</h5>
                        <p>Para contactar con el Titular del Sitio Web o en el uso autorizado del mismo, el Usuario puede
                        que facilite determinados datos de carácter personal (en adelante, los “Datos Personales”). El
                        Titular tratará los Datos Personales con las finalidades así como bajo el resto de condiciones
                        definidas en su Política de Privacidad, de conformidad a los dispuesto en Reglamento (UE)
                        2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la protección de
                        las personas físicas en lo que respecta al tratamiento de datos personales y a la libre
                        circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento General de
                        Protección de Datos), así como la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos
                        Personales y garantía de los derechos digitales y sus normas de desarrollo.</p>

                        <p>La referida Política de Privacidad puede consultarse íntegramente 
                            <a href="/politica">pinchando aquí.</a>
                        </p>

                        <p>El Titular ha adoptado, y seguirá adoptando, las medidas de seguridad de protección de los datos
                        personales legalmente requeridos y procurará instalar otros medios y medidas técnicas y
                        organizativas de protección adicionales. No obstante, el Usuario debe ser consciente de que las
                        medidas de seguridad en Internet no son inexpugnables debiendo llevar a cabo en todo momento una
                        conducta diligente respecto de estos.</p>

                        <h5>4. Utilización de Cookies.</h5>
                        <p>El Titular se sirve del uso de Cookies propias y de terceros cuando el Usuario navega por el
                        Sitio Web.</p>

                        <p>Las Cookies son ficheros de datos de capacidad muy limitada que se generan en el ordenador del
                        Usuario permitiendo obtener, entre otra, la siguiente información:</p>
                        <ol class="list-latin-letter">
                            <li>La fecha y hora de la última vez que visitó el Sitio Web;</li>
                            <li>El diseño de contenidos que el Usuario escogió en su primera visita al Sitio Web;</li>
                            <li>Datos de contacto; y</li>
                            <li>Los elementos de seguridad que intervienen en el control de acceso a las áreas restringidas.</li>
                        </ol>                   
                        
                        <p>El Usuario tiene la opción de impedir la generación de cookies mediante la selección de la
                        correspondiente opción en su programa navegador.</p>

                        <p>La Política de Cookies de este Sitio Web puede consultarse íntegramente<a href="/cookies"> pinchando aquí.</a>
                        </p>

                        <h5>5. Derechos de Propiedad Intelectual del Sitio Web</h5>
                        <p>Los derechos de propiedad intelectual del Sitio Web, su diseño, contenido, estructura de
                        navegación, software, bases de datos y sus distintos elementos gráficos o conceptuales son de
                        exclusiva propiedad del Titular o de terceros que han autorizado debidamente su uso. Sólo al
                        Titular corresponde el ejercicio exclusivo de los derechos de explotación de los referidos
                        derechos de propiedad intelectual en cualquier forma y, en especial, los de reproducción,
                        distribución, comunicación pública y transformación.</p>

                        <p>La condición de Usuario no implica de modo alguno cesión u autorización para el ejercicio de
                        ninguno de los derechos referidos. El ejercicio de estos se considerará en todo caso prohibido
                        salvo autorización previa y escrita en contrario.</p>

                        <h5>6. Servicios y productos promocionados en el Sitio Web.</h5>
                        <h6>6.1. Naturaleza.</h6>
                        <p>La información sobre servicios y productos, precios, ofertas y/o promociones del Titular
                        facilitada a través del Sitio Web no tiene naturaleza contractual sino meramente ilustrativa,
                        careciendo de fuerza vinculante entre el Titular y el Usuario. Solo serán obligatorios los
                        contratos u otros documentos análogos otorgados al efecto entre el Titular y el Usuario conforme
                        las condiciones generales y/o particulares aplicables a los servicios y productos objeto de
                        contratación.</p>

                        <h6>6.2. Mutabilidad. Información provisional.</h6>
                        <p>El Titular se reserva el derecho a modificar la información presentada en este Sitio Web sobre
                        servicios, productos, precios, ofertas y/o promociones en cualquier momento. El Titular se
                        compromete no obstante a hacer todos los esfuerzos dentro de sus medios para mantener la
                        información contenida en el Sitio Web de forma actualizada, veraz y sin errores tipográficos o
                        de otra índole.</p>

                        <p>En el caso que en algún momento se produjera algún error de este tipo, ajeno en todo momento a
                        la voluntad del Titular, se procedería inmediatamente a su corrección.</p>

                        <p>Asimismo, el contenido del Sitio Web podría, en ocasiones, mostrar información provisional sobre
                        servicios, precios, ofertas y/o promociones. En el caso que la información facilitada no
                        correspondiera a las características de los servicios, precios, ofertas y/o promociones el
                        cliente podrá comunicar este hecho al Titular para que proceda a la subsanación del error.</p>

                        <p>El Titular no es responsable ni directa ni indirectamente de ninguna de las informaciones,
                        contenidos, afirmaciones y expresiones de terceros relacionadas con los servicios, productos,
                        precios, ofertas y/o promociones recogidos en este Sitio Web. Dicha responsabilidad recae en
                        todo momento en los titulares, cesionarios y/o autorizados de estos y, en todo caso, en las
                        personas físicas o jurídicas, públicas o privadas, que emitan las referidas informaciones,
                        contenidos, afirmaciones y/o expresiones.</p>

                        <h6>6.3. Derechos de Propiedad Industrial e Intelectual de los productos y servicios promocionados
                        en este Sitio Web</h6>
                        <p>El Titular es propietario y/o licenciatario de los derechos de propiedad industrial referidos a
                        sus productos y servicios, y específicamente de los relativos a sus marcas registradas y a las
                        creaciones, fotografías e ilustraciones que el Titular pone a disposición del Usuario, cuya
                        descarga y uso queda autorizada para uso estrictamente privado y sin fines comerciales.</p> 

                        <p>Respecto a los productos y servicios de terceros, el Titular reconoce a favor de sus
                        propietarios y/o licenciatarios los correspondientes derechos de propiedad industrial e
                        intelectual, no implicando su sola mención o aparición en el Sitio Web la existencia de derechos
                        o responsabilidad alguna del titular sobre los mismos, como tampoco respaldo, patrocinio, o
                        recomendación por parte del Titular, a no ser que se manifieste de manera expresa.</p>

                        <p>La utilización no autorizada de la información contenida en el Sitio Web, su comercialización,
                        así como cualquier otra forma de aprovechamiento lucrativo, al igual que la lesión de los
                        derechos de Propiedad Intelectual o Industrial del Titular o de terceros propietarios y/o
                        licenciatarios dará lugar a las responsabilidades legalmente establecidas.</p>

                        <h5>7. Autorización temporal de uso de este Sitio Web y sus elementos</h5>
                        <p>Se autoriza la visualización, impresión y descarga parcial del contenido del Sitio Web,
                        incluidos sus avisos legales, sólo y exclusivamente si concurren las siguientes condiciones:</p>
                        <p>7.1. Que sea compatible con los fines del Sitio Web.</p>
                        <p>7.2. Que se realice con el exclusivo ánimo de obtener la información contenida para uso personal
                        y privado. Se prohíbe expresamente su utilización con fines comerciales o para su distribución,
                        comunicación pública, transformación o descompilación.</p>
                        <p>7.3. Que ninguno de los contenidos relacionados en la Web sea modificado de manera alguna.</p>
                        <p>7.4. Que ningún gráfico, icono o imagen disponible en la Web sea utilizado, copiado o
                        distribuido separadamente del texto o resto de imágenes que lo acompañan.</p>

                        <h5>8. Hiperenlaces</h5>
                        <h6>8.1. Hiperenlaces hacía el Sitio Web.</h6>
                        <p>El Usuario y, en general, aquellas personas que se propongan establecer un hiperenlace entre su
                        página web y el Sitio Web (en adelante, el «Hiperenlace») deberán cumplir todas y cada una de
                        las condiciones siguientes:</p>
                        <ol class="list-latin-letter">
                            <li>El Hiperenlace permitirá sólo el acceso a la página de inicio (home page) y no podrá
                        reproducirlas de ninguna forma;</li>
                            <li>En ningún caso se creará un marco (frame, framing) sobre las páginas del Sitio Web.;</li>
                            <li>No se realizarán manifestaciones o indicaciones falsas, inexactas o incorrectas sobre el
                        Titular, sus directivos, socios, colaboradores, empleados, las páginas del Sitio Web y los
                        bienes y servicios ofertados y/o suministrados;</li>
                            <li>No se declarará ni se dará a entender que el Titular ha autorizado el Hiperenlace o que ha
                        supervisado o asumido de cualquier forma los servicios ofrecidos o puestos a disposición de la
                        página web en la que se establece el Hiperenlace;</li>
                        <li>Con excepción de aquellos signos que formen parte del mismo Hiperenlace, la página web en la
                        que se establezca el Hiperenlace no contendrá ninguna marca, nombre comercial, rótulo de
                        establecimiento, denominación, logotipo, eslogan u otros signos distintivos pertenecientes al
                        Titular; y</li>
                        <li>La página web en la que se establezca el Hiperenlace no contendrá informaciones o contenidos
                        ilícitos, contrarios a la moral y a las buenas costumbres generalmente aceptadas y al orden
                        público, así como tampoco contendrá contenidos contrarios a cualesquiera derechos de terceros.</li>
                        </ol>
                        
                        <p>El establecimiento del Hiperenlace no implica en ningún caso la existencia de relaciones
                        jurídicas (contractual, asociativa, de representación, ...) o de otro tipo entre quien lo
                        implemente y el Titular. Por tanto, no podrán entenderse, directa o indirectamente, que el
                        Titular acepta, promueve o aprueba sus informaciones, contenidos, servicios o productos.</p>

                        <h6>8.2. Enlaces a otras páginas web; exención de responsabilidad del Titular</h6>
                        <p>EL Titular no asume responsabilidad alguna derivada de los contenidos enlazados desde el Sitio
                        Web, siempre que sean ajenos al mismo, ni garantiza la ausencia de virus u otros elementos en
                        los mismos que puedan producir alteraciones en el sistema informático (hardware y software), en
                        los documentos o los ficheros del Usuario, excluyendo cualquier responsabilidad por los daños de
                        cualquier clase que pudiesen causarse al Usuario por este motivo.</p>

                        <h6> 8.2.1. Ilicitud o no conformidad a derecho de los contenidos de los sitios webs externos</h6>
                        <p>En el caso de que cualquier Usuario considerase que el contenido o los servicios prestados por
                        las páginas enlazadas son ilícitos o lesionan bienes o derechos del propio Usuario o de un
                        tercero, susceptibles de indemnización lo pondrá inmediatamente en conocimiento del Titular. Se
                        entenderán en todo caso como ilícitos los contenidos y/o servicios que consistan en:</p>
                        <ol class="list-latin-letter">
                            <li>Actividades o contenidos susceptibles de ser considerados delictivos conforme la normativa
                        penal española.</li>
                            <li>Actividades o contenidos que violen derechos de propiedad intelectual o industrial.</li>
                            <li>Actividades o contenidos que pongan en peligro el orden público, la investigación penal, la
                        seguridad pública y la defensa nacional.</li>
                            <li>Actividades o contenidos que pongan en peligro la protección de la salud pública, el respeto
                        a la dignidad de la persona y al principio de no discriminación, y la protección de la salud y
                        la infancia.</li>
                        </ol>                

                        <h6> 8.2.2. Procedimiento de notificación en caso de realización de actividades de carácter ilícito.</h6>
                        <p>Verificada a juicio de cualquier Usuario la existencia de hechos o circunstancias ilícitas de la
                        utilización de cualquier contenido y/o de la realización de cualquier actividad en las páginas
                        web incluidas o accesibles a través del Sitio Web, deberá enviar una notificación escrita al
                        Titular bien a la dirección postal o electrónica indicadas más arriba, en la que se contengan
                        los siguientes extremos:</p>
                        <ol class="list-latin-letter">
                            <li>datos personales del reclamante: nombre completo, dirección, número de teléfono y dirección
                        de correo electrónico (sujetos a la antes referida Política de Privacidad);</li>
                            <li>especificación de la supuesta actividad ilícita llevada a cabo en el Sitio Web o páginas web
                        de terceros y, en particular, cuando se trate de una supuesta violación de derechos, indicación
                        precisa y concreta de los contenidos protegidos, así como de su localización en el Sitio Web o
                        páginas web de terceros;</li>
                            <li>hechos o circunstancias que revelan el carácter ilícito de dicha actividad;</li>
                            <li>declaración expresa, clara y bajo la responsabilidad del reclamante de que la información
                        proporcionada en la notificación es exacta y del carácter ilícito de la utilización de los
                        contenidos o de la realización de las actividades descritas.</li>
                        </ol>                    

                        <h5>9. Modificación del Sitio Web</h5>
                        <p>El Titular se reserva la facultad de efectuar, en cualquier momento y sin necesidad de previo
                        aviso, modificaciones y actualizaciones de la información contenida en el Sitio Web, de la
                        configuración y presentación de éste y de las presentes Condiciones de Uso.</p>

                        <h5>10. Exclusión de garantía por disponibilidad de este sitio Web o sus contenidos, así como por su
                        uso.</h5>
                        <p>El Titular no garantiza la inexistencia de interrupciones o errores en el acceso al Sitio Web o
                        a su contenido, ni que éste se encuentre actualizado. El Titular llevará a cabo, siempre que no
                        concurran causas que lo hagan imposible o de difícil ejecución, y tan pronto tenga noticia de
                        los errores, desconexiones o falta de actualización en los contenidos, todas aquellas labores
                        tendentes a subsanar los errores, restablecer la comunicación y actualizar los contenidos.</p>

                        <p>Se hace saber al Usuario que el servidor en donde se encuentra alojado el Sitio Web se encuentra
                        ubicado físicamente en la Unión Europea. Es este proveedor (ISP) quien pres presta servicios de alojamiento y conectividad del Sitio Web.</p>

                        <p>Tanto el acceso al Sitio Web como el uso no consentido que pueda efectuarse de la información
                        contenida en el mismo es de la exclusiva responsabilidad de quien lo realiza. El Titular no
                        responderá de ninguna consecuencia, daño o perjuicio que pudieran derivarse de dicho acceso o
                        uso. El Titular no se hace responsable de los errores de seguridad, que se puedan producir ni de
                        los daños que puedan causarse al sistema informático del Usuario (hardware y software), o a los
                        ficheros o documentos almacenados en el mismo, como consecuencia de:</p> 
                        <ol class="list-latin-letter">
                            <li>la presencia de un virus en el ordenador del usuario que sea utilizado para la conexión a
                        los servicios y contenidos del Sitio Web</li>
                            <li>un mal funcionamiento del navegador</li>
                            <li>del uso de versiones no actualizadas del mismo</li>
                        </ol>                       

                        <h5>11. Régimen contractual de las imágenes o fotos proporcionadas por el Usuario</h5>
                        <p> Además de la garantía y declaraciones establecidas en estas Condiciones de Uso, al realizar un
                        envío a través del Sitio Web o dirigido al Titular que contenga imágenes, fotografías, dibujos o
                        cualquier otro elemento gráfico en todo o en parte, (en adelante conjunta e indistintamente
                        denominadas las "imágenes"), el Usuario declara y garantiza que:</p>
                        <ol class="list-latin-letter">
                            <li>Es el propietario de los derechos de autor de la imagen o que el propietario de los derechos
                        de esta le ha concedido permiso para utilizar la imagen, o cualquier contenido o imagen
                        incluidos en ella de acuerdo con la forma y finalidad de su uso y conforme lo permitan estas
                        Condiciones de Uso y el Sitio Web o los servicios del Titular,</li>
                            <li>Tiene los derechos necesarios para otorgar las licencias y sublicencias descritas en estas
                        Condiciones de Uso; y</li>
                            <li>Las personas que aparecen en dicha imagen, si las hay, han dado su consentimiento para el
                        uso de la imagen según se establece en estas Condiciones de Uso, incluyendo sin limitación, la
                        distribución, exposición pública y reproducción de dicha imagen.</li>
                        </ol>                      
                        
                        <h5>12. Legislación aplicable y Jurisdicción competente a las presentes Condiciones de Uso</h5>
                        <p>Todas las cuestiones que se susciten entre el Titular y el Usuario relativas a la
                        interpretación, cumplimiento y validez de las presentes Condiciones de Uso se regirán por sus
                        propias cláusulas y, en lo que en ellas no estuviese previsto, de acuerdo con la legislación
                        española vigente en cada momento.</p>

                        <p> Titular y el Usuario, con renuncia expresa a cualquier otro fuero, se someten a la
                        jurisdicción de los Juzgados y Tribunales de la ciudad de Madrid con independencia de que el
                        último de los citados tenga o no su domicilio o residencia habitual en España.</p>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

//import condiciones from '@/components/condiciones.vue';

export default {
    name: 'avisolegal',
    
    components: {            
        //condiciones,
    },
    data() {
        return {
            
        }
    },
    computed: {

    },
    mounted() {            

    },
    methods: {        

        //iconoStd(std) {                
            //return this.estados[std];
        //}
    }
}
</script>